export const selectFileUrl=state=>state.views.view.fileUrl;